import { makeStyles } from "@fluentui/react-components";
import { projectIqTokens } from "apps/project-iq/theme/projectIqTokens";
import { designTokens } from "theme/customTheme";

export const useStyles = makeStyles({
  panel: {
    backgroundColor: projectIqTokens.workspaceNavBg,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    overflowY: "auto",
    overflowX: "hidden",
    fontFamily: projectIqTokens.fontFamily,
  },

  workspaceHeader: {
    padding: "16px 16px 14px",
    borderBottom: `1px solid ${projectIqTokens.line}`,
    flexShrink: 0,
  },

  clientRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },

  buildingIcon: {
    fontSize: "14px",
    color: projectIqTokens.muted,
    flexShrink: 0,
  },

  clientName: {
    fontSize: "12px",
    fontWeight: 600,
    color: projectIqTokens.muted,
  },

  workspaceName: {
    fontSize: "16px",
    fontWeight: 800,
    color: projectIqTokens.ink,
    letterSpacing: "-.01em",
    lineHeight: "1.25",
    marginTop: "4px",
  },

  codeLine: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginTop: "7px",
  },

  codeBadge: {
    fontFamily: projectIqTokens.fontFamilyMono,
    fontSize: "11.5px",
    color: projectIqTokens.faint,
  },

  statusPill: {
    display: "flex",
    alignItems: "center",
    gap: "5px",
    fontSize: "11.5px",
    fontWeight: 700,
    color: projectIqTokens.navItemActiveText,
  },

  statusDot: {
    width: "6px",
    height: "6px",
    borderRadius: "999px",
    backgroundColor: projectIqTokens.sidebarAccent,
    display: "inline-block",
    flexShrink: 0,
  },

  navContent: {
    flex: 1,
    overflowY: "auto",
    overflowX: "hidden",
    padding: "8px 10px",
  },

  sectionHeader: {
    display: "block",
    textAlign: "center",
    backgroundColor: projectIqTokens.sidebarAccent,
    color: designTokens.neutral.white,
    fontSize: "11.5px",
    fontWeight: 800,
    letterSpacing: ".07em",
    textTransform: "uppercase",
    padding: "6px 12px",
    borderRadius: "10px",
    margin: "4px 2px 8px",
    boxShadow: projectIqTokens.navSectionHeaderShadow,
  },

  sectionHeaderFirst: {
    marginTop: 0,
  },

  groupLabel: {
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: ".07em",
    textTransform: "uppercase",
    color: projectIqTokens.sidebarMuted,
    margin: "16px 10px 8px",
    padding: 0,
    display: "block",
  },

  navItem: {
    padding: "8px 10px",
    borderRadius: "9px",
    border: "none",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "11px",
    width: "100%",
    boxSizing: "border-box",
    textAlign: "left",
    textDecoration: "none",
    fontSize: "13.5px",
    fontWeight: 600,
    color: projectIqTokens.navItemText,
    backgroundColor: "transparent",
    transition: `background-color ${designTokens.transition.fast}`,
    ":hover": {
      backgroundColor: projectIqTokens.bg2,
    },
  },

  navItemActive: {
    backgroundColor: projectIqTokens.navItemActiveBg,
    color: projectIqTokens.navItemActiveText,
    fontWeight: 700,
  },

  navIconContainer: {
    width: "26px",
    height: "26px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
  },

  navIcon: {
    fontSize: "19px",
  },

  navIconInactive: {
    color: projectIqTokens.navIconInactive,
  },

  navIconActive: {
    color: projectIqTokens.navItemActiveText,
  },

  navLabel: {
    flexShrink: 1,
    minWidth: 0,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  navExternalIcon: {
    fontSize: "12px",
    flexShrink: 0,
    color: projectIqTokens.sidebarMuted,
  },

  deliveryGroupHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    margin: "16px 10px 8px",
  },

  deliveryGroupLabel: {
    fontSize: "11px",
    fontWeight: 700,
    letterSpacing: ".07em",
    textTransform: "uppercase",
    color: projectIqTokens.sidebarMuted,
    padding: 0,
    display: "block",
  },

  addCapabilityButton: {
    background: "transparent",
    border: "none",
    cursor: "pointer",
    color: projectIqTokens.sidebarMuted,
    padding: "2px",
    display: "flex",
    alignItems: "center",
    borderRadius: "4px",
    ":hover": {
      color: projectIqTokens.ink,
      backgroundColor: projectIqTokens.bg2,
    },
  },
});
